module.exports = __webpack_public_path__ + "img/RegisterSpringBoot.6bb17466.png";